export { Page as default } from '@ui/views/Index';
export { getStaticProps } from '@ui/views/Index/getStatic';
